import React from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { INVESTMENT_STATUS, PROJECT_STATUS } from "constants/status";
import { useFormattedMessage, useSideModalScrollToTop } from "hooks";
import PrevButton from "components/PrevButton";
import SideModal from "components/SideModal";
import InvestmentPictureOverview from "components/InvestmentPictureOverview";
import FormatDateWithLocale from "components/FormatDateWithLocale";

import NewLoader from "./NewLoader";
import { selectIsUserVIP } from "store/user/account/selectors";

const messages = {
    investmentHeading: "continue_investment_heading",
    withReservedShares: "reedem_your_reserved_shares",
    withInitializedInvestment: "continue_investment_with_initialized_investment",
    continueButtonText: "continue_investment_continue_button_text",
    cancelButtonText: "cancel_investment_cancel_button_text",
    cancellingButtonText: "abort",
    disableButtonText: "disable_investment_disable_button_text",
};

export const RenderContinueData = ({
    withInvestment,
    investmentData,
    onContinue,
    onCancel,
    isCancelLoading,
    VIPUser,
    backSlideEffect = "",
    project,
}) => {
    useSideModalScrollToTop();

    const { formatMessage } = useFormattedMessage();

    const image = project?.images?.teaserImage ? `${project?.images?.teaserImage?.path}?h=150` : null;
    const title = project?.title;
    const location = `${project?.address ? project?.address.city : ""}${
        project?.address ? `, ${project?.address?.country}` : ""
    }`;
    const projectStatus = project?.status?.status;
    const date = investmentData?.CreatedDate;
    const splitDate = date && date.split("_");
    const newDate = splitDate && splitDate[0] && new Date(splitDate[0]);
    const ExpirationDate = newDate && <FormatDateWithLocale date={newDate} />;
    const price = 1;
    const shares = investmentData?.Shares;
    const amount = investmentData?.Amount;
    const status = investmentData?.StatusInvestment;

    const heading =
        status && status === INVESTMENT_STATUS.RESERVED
            ? formatMessage(messages.withReservedShares)
            : formatMessage(messages.withInitializedInvestment);

    const isButtonActive = !!(
        projectStatus &&
        (projectStatus === PROJECT_STATUS.FUNDING_ACTIVE || (projectStatus === PROJECT_STATUS.VIP_FUNDING && VIPUser))
    );

    return (
        <div className={`render-continue-data ${withInvestment ? "investment-process-container" : ""} ${backSlideEffect}`}>
            <h3>{heading}</h3>
            <InvestmentPictureOverview
                image={image}
                title={title?.toString?.()}
                location={location}
                shares={shares}
                amount={amount}
                createdDate={ExpirationDate}
                price={price}
            />
            {isButtonActive ? (
                <button disabled={isCancelLoading} className="mw-100" onClick={onContinue}>
                    {formatMessage(messages.continueButtonText)}
                </button>
            ) : (
                <button className="mw-100 disable-grey">{formatMessage(messages.disableButtonText)}</button>
            )}
            <button
                disabled={isCancelLoading}
                className={`secondary mw-100 ${isCancelLoading ? "disable-grey" : ""}`}
                onClick={onCancel}
            >
                {isCancelLoading ? (
                    <>
                        <NewLoader /> {formatMessage(messages.cancellingButtonText)}
                    </>
                ) : (
                    formatMessage(messages.cancelButtonText)
                )}
            </button>
        </div>
    );
};

const InvestmentContinueModal = ({
    className,
    open,
    investmentData,
    onCloseButtonClick,
    isCancelLoading,
    onCancel,
    onContinue,
    onBackButtonClick,
    isVIPUser,
    project,
}) => {
    const { formatMessage } = useFormattedMessage();

    return (
        <SideModal
            className={`investment-continue-modal ${className}`}
            heading={formatMessage(messages.investmentHeading)}
            open={open}
            onCloseButtonClick={() => {
                onCloseButtonClick();
            }}
        >
            <RenderContinueData
                VIPUser={isVIPUser}
                investmentData={investmentData}
                isCancelLoading={isCancelLoading}
                onCancel={onCancel}
                onContinue={onContinue}
                project={project}
            />
            {onBackButtonClick && (
                <div className="bottom-bar-container">
                    <PrevButton
                        onClick={() => {
                            onBackButtonClick();
                        }}
                    />
                </div>
            )}
        </SideModal>
    );
};

const mapStateToProps = createStructuredSelector({
    isVIPUser: selectIsUserVIP,
});

export default connect(mapStateToProps)(InvestmentContinueModal);
